namespace appn.views.taskRecurring.createOrEdit {

    export function init(): void {
        appn.tasks.initRecurring();
    }
}
